// extracted by mini-css-extract-plugin
export var lg = "_3o-4";
export var md = "_3o-3";
export var sm = "_3o-2";
export var xs = "_3o-1";
export var xxs = "_3o-0";